<template>
  <div class="layout-container">
    <!-- 导航栏 -->
    <nav>
      <img id="logo" :src="baseUrl + logo" v-if="logo">
      <aside ref="aside">
        <ul id="menu">
          <li v-for="item, index in menuList" :key="index" :data-menuanchor="item.code"
            :class="index === 0 ? 'active' : ''" @click="handleMove(index)">
            <a :href="'#' + item.code">{{ item.name }}</a>
          </li>
        </ul>
        <el-badge :is-dot="Boolean(tipList.length)">
          <i class="el-icon-bell" @click="openDrawer('tip')"></i>
        </el-badge>
        <el-dropdown>
          <span class="el-dropdown-link">
            <img :src="userInfo.headUrl ? baseUrl + userInfo.headUrl : require('../assets/avatar.jpg')">
            <span class="username">{{ userInfo.name }}</span>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-user" @click.native="$router.push('/personal')">个人设置</el-dropdown-item>
            <el-dropdown-item icon="el-icon-switch-button" @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </aside>
    </nav>
    <!-- 滚动页 -->
    <full-page v-if="appList.length" :options="options" ref="fullPage">
      <div id="content">
        <div class="section">
          <Home :pageIndex="pageIndex" :appList="appList" :clickApp="clickApp" @click.native="closeDrawer" />
        </div>
        <div class="section">
          <Info :handleScroll="handleScroll" :openDialog="openDialog" @click.native="closeDrawer"
            :fixedAppUrl="fixedAppUrl" />
        </div>
        <div class="section" v-for="item, index in appList" :key="item.code">
          <Apps :appIndex="index" :appList="appList" :clickApp="clickApp" @click.native="closeDrawer" />
        </div>
      </div>
    </full-page>
    <!-- 工具栏 -->
    <footer ref="footer">
      <div class="suggestion">
        <img :src="randomSug.src" alt="">
        <div class="info">
          <div class="title">{{ randomSug.title }}</div>
          <div class="desc">{{ randomSug.desc }}</div>
        </div>
        <div class="action">
          <a :href="jumpURL + randomSug.url" target="_blank">{{
            randomSug.action }}</a>
        </div>
      </div>
      <label class="msg btn flex-row" @click="openDrawer('msg')">
        <el-badge :is-dot="Boolean(msgList.length)">
          <span>未读消息</span>
        </el-badge>
      </label>
      <label class="app btn flex-row" @click="openDrawer('app')">
        <span>常用应用</span>
      </label>
    </footer>
    <!-- 侧边栏 -->
    <div class="drawer flex-column" ref="drawer">
      <div class="tip-wrapper" v-if="drawerType === 'tip'">
        <a class="first flex-row" :href="fixedAppUrl.systemReminder" target="_blank">
          <span>进入【系统提醒】查看更多</span>
          <i class="el-icon-right"></i>
        </a>
        <div class="msg-item flex-row" v-for="item in tipList" @click="openDialog('tip', item)">
          <div class="date">
            <div class="day">{{ item.sendTime.substring(8, 10) }}</div>
            <div class="year-month">{{ item.sendTime.substring(0, 7) }}</div>
          </div>
          <el-divider direction="vertical"></el-divider>
          <div class="content">
            <div class="top flex-row">
              <div class="title">{{ item.title }}</div>
              <div class="time">{{ item.sendTime.substring(11, 19) }}</div>
            </div>
            <div class="detail">{{ item.content }}</div>
          </div>
        </div>
      </div>
      <div class="msg-wrapper" v-if="drawerType === 'msg'">
        <a class="first flex-row" :href="fixedAppUrl.messageCenter" target="_blank">
          <span>进入【消息中心】查看更多</span>
          <i class="el-icon-right"></i>
        </a>
        <div class="msg-item flex-row" v-for="item in msgList" @click="openDialog('msg', item)">
          <div class="date">
            <div class="day">{{ item.sendTime.substring(8, 10) }}</div>
            <div class="year-month">{{ item.sendTime.substring(0, 7) }}</div>
          </div>
          <el-divider direction="vertical"></el-divider>
          <div class="content">
            <div class="top flex-row">
              <div class="title">{{ item.title }}</div>
              <div class="time">{{ item.sendTime.substring(11, 19) }}</div>
            </div>
            <div class="detail">{{ item.content }}</div>
          </div>
        </div>
      </div>
      <div class="app-wrapper" v-if="drawerType === 'app'">
        <div class="first flex-row" @click="$router.push('/common')">
          <span>常用应用设置</span>
          <i class="el-icon-right"></i>
        </div>
        <div class="apps-item flex-row" v-for="item in comList"
          @click="clickApp(item.sourceType, item.idOperation, item.opeUrl)">
          <img :src="baseUrl + item.opeIcon">
          <span>{{ item.opeName }}</span>
        </div>
      </div>
    </div>
    <!-- 弹窗 -->
    <div class="dialog" ref="dialog" @click.self="closeDialog">
      <div class="dialog-body" v-if="dialogInfo.type === 'todo'">
        <ul>
          <li v-if="dialogInfo.workType == 1">
            <i class="el-icon-office-building"></i>
            <dt>校区：</dt>
            <dd>{{ dialogInfo.schoolName }}</dd>
          </li>
          <el-divider v-if="dialogInfo.workType == 1"></el-divider>
          <li>
            <i class="el-icon-date"></i>
            <dt>日期：</dt>
            <dd>{{ dialogInfo.workDate }}</dd>
          </li>
          <el-divider></el-divider>
          <li>
            <i class="el-icon-time"></i>
            <dt>时间：</dt>
            <dd>{{ dialogInfo.startTime + ' ~ ' + dialogInfo.endTime }}</dd>
          </li>
          <el-divider></el-divider>
          <li>
            <i class="el-icon-location-outline"></i>
            <dt>地点：</dt>
            <dd>{{ dialogInfo.address }}</dd>
          </li>
          <el-divider></el-divider>
          <li>
            <i class="el-icon-video-camera"></i>
            <dt>事项：</dt>
            <dd>{{ dialogInfo.content }}</dd>
          </li>
          <el-divider></el-divider>
          <li>
            <i class="el-icon-service"></i>
            <dt>负责人：</dt>
            <dd>{{ dialogInfo.headUser }}</dd>
          </li>
          <el-divider></el-divider>
          <li>
            <i class="el-icon-user"></i>
            <dt>参与人员：</dt>
            <dd>{{ dialogInfo.personnel }}</dd>
          </li>
          <el-divider></el-divider>
          <li>
            <i class="el-icon-goods"></i>
            <dt>物料：</dt>
            <dd>{{ dialogInfo.goods }}</dd>
          </li>
          <el-divider></el-divider>
          <li>
            <i class="el-icon-chat-dot-square"></i>
            <dt>备注：</dt>
            <dd>{{ dialogInfo.notes }}</dd>
          </li>
        </ul>
        <img v-if="dialogInfo.importantFlag" src="../assets/important.png">
      </div>
      <div class="dialog-body" v-else>
        <div class="dialog-title">{{ dialogInfo.title || dialogInfo.name }}
        </div>
        <div class="dialog-content" v-html="dialogInfo.htmlContent || dialogInfo.content"></div>
        <div class="dialog-footer">
          <div class="type">{{ dialogInfo.kindView || dialogInfo.senderName ||
            dialogInfo.categoryName + ' / ' + dialogInfo.departmentName + ' / ' + dialogInfo.publishUser }}</div>
          <div class="time">{{ dialogInfo.sendTime || dialogInfo.publishTime }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const { jumpURL } = projectConfig
import { getConfigInfoApi, getUserInfoApi, getAppListApi, getTipListApi, getMsgListApi, getCommonAppsApi, logUserClickApi, getSystemParamApi } from './api'
import Home from '../views/home'
import Apps from '../views/apps'
import Info from '../views/info'
import cloneDeep from 'lodash.clonedeep'
export default {
  name: 'Layout',
  components: { Home, Apps, Info },
  data() {
    return {
      jumpURL,
      baseUrl: localStorage.getItem('baseUrl'),
      logo: localStorage.getItem('logo'),
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
      options: {
        menu: '#menu',
        anchors: [],
        lockAnchors: true,
        navigation: true,
        navigationPosition: 'left',
        navigationTooltips: [],
        keyboardScrolling: true,
        normalScrollElements: '.scroll,.drawer,.dialog',
        onLeave: this.onLeave
      },
      menuList: [],
      appList: [],
      fixedAppUrl: {
        systemReminder: '',
        messageCenter: '',
        noticeCenter: '',
        weekCalendar: ''
      },
      pageIndex: 0,
      tipList: [],
      msgList: [],
      comList: [],
      sugList: [{
        src: require('../assets/suggestion/sug1.png'),
        title: '是否已完成基础数据的录入？',
        desc: '在【基础管理】中可以新建学校、年级、专业及教室信息，并导入教师、学生等基础数据，为其它应用的使用做好准备！',
        action: '去录入',
        url: '/schoolManage/'
      }, {
        src: require('../assets/suggestion/sug2.png'),
        title: '你有待处理的系统提醒吗？',
        desc: '点击页面右上角的提醒按钮，你可以查看未处理的提醒，并点击查看详情。同时，也可以在【系统提醒】中查看所有提醒！',
        action: '去处理',
        url: '/systemReminder/'
      }, {
        src: require('../assets/suggestion/sug3.png'),
        title: '如何发一条放假通知？',
        desc: '在【通知中心】中，你可以创建通知、选择发送的类型及部门，然后保存后并发送通知。当然，你也可以置顶一些重要的通知！',
        action: '发通知',
        url: '/noticeCenter/'
      }, {
        src: require('../assets/suggestion/sug4.png'),
        title: '发一条消息给同事吧！',
        desc: '在【消息中心】中，你可以选择发送对象，输入消息内容，然后发送消息。如果你愿意，保存为草稿也是一个不错的选择！',
        action: '发消息',
        url: '/messageCenter/'
      }, {
        src: require('../assets/suggestion/sug5.png'),
        title: '本周要做的事情完成了吗？',
        desc: '在【周历】中新增个人或校区待办事项，每日登录智慧校园平台即可查看当日事项，能更好地提醒你完成教学任务！',
        action: '去查看',
        url: '/weekCalendar/'
      }],
      randomSug: '',
      drawerType: '',
      dialogInfo: ''
    }
  },
  beforeCreate() {
    // 设备类型
    const isMobile = /Mobile|Android|iPhone/i.test(navigator.userAgent)
    if (isMobile) return window.location.href = `${jumpURL}/mobile/`
  },
  async created() {
    // 用户信息
    const { data } = await getUserInfoApi()
    this.userInfo = data
    localStorage.setItem('userInfo', JSON.stringify(data))
    // 应用列表
    await this.getAppList()
    // 系统提醒
    const { rows } = await getTipListApi({ pageNo: 1, pageSize: 8, status: 0 })
    this.tipList = rows
    // 未读消息
    const { data: { messageList } } = await getMsgListApi({ readStatus: 0, pageParam: { current: 1, size: 8 } })
    this.msgList = messageList
    // 常用应用
    const { data: { userCommonAppList } } = await getCommonAppsApi()
    this.comList = userCommonAppList
    // 随机建议
    const index = Math.floor(Math.random() * this.sugList.length)
    this.randomSug = this.sugList[index]
  },
  methods: {
    async getAppList() {
      const { data: { userOperationList } } = await getAppListApi({ platformType: 1 })
      this.appList = userOperationList.filter(item => item.children.length > 0)
      this.menuList = cloneDeep(this.appList)
      this.menuList.unshift({ code: 'info', name: '校园动态' })
      this.menuList.unshift({ code: 'home', name: '首页' })
      this.options.anchors = this.menuList.map(item => item.code)
      this.options.navigationTooltips = this.menuList.map(item => item.name)
      Object.keys(this.fixedAppUrl).forEach(item => this.findAppUrl(item))
    },
    findAppUrl(code) {
      this.appList.forEach(item => {
        item.children.forEach(_item => {
          if (_item.code === code) this.fixedAppUrl[code] = jumpURL + _item.url
        })
      })
    },
    async clickApp(sourceType, id, url) {
      await logUserClickApi({ idOperate: id, type: 1 })
      if (sourceType === 1) {
        url = jumpURL + url
      } else {
        const { data } = await getSystemParamApi(this.userInfo.id)
        for (const key in data) {
          url = url.replace(key, data[key])
        }
      }
      window.open(url)
    },
    async logout() {
      localStorage.clear()
      this.$router.push('/login')
    },
    handleMove(index) {
      this.$refs.fullPage.api.moveTo(index + 1, index)
    },
    handleScroll(state) {
      this.$refs.fullPage.api.setAllowScrolling(state)
    },
    onLeave(prevPage, nextPage) {
      this.pageIndex = nextPage.index
      this.closeDrawer()
      this.closeDialog()
      this.$refs.footer.style.height = nextPage.index !== 0 ? 0 : 'calc(90*var(--ratio))'
      this.$refs.footer.style.opacity = nextPage.index !== 0 ? 0 : 1
      if (this.pageIndex === 0) {
        setTimeout(() => {
          this.$refs.aside.classList.remove('white')
          this.$refs.drawer.classList.remove('white')
        }, 100)
      } else {
        setTimeout(() => {
          this.$refs.aside.classList.add('white')
          this.$refs.drawer.classList.add('white')
        }, 500)
      }
    },
    openDrawer(type) {
      this.drawerType = type
      this.$refs.drawer.style.opacity = 1
      if (type === 'app') this.$refs.drawer.style.width = 'calc(251*var(--ratio))'
      else this.$refs.drawer.style.width = 'calc(501*var(--ratio))'
    },
    closeDrawer() {
      this.$refs.drawer.style.width = 0
      this.$refs.drawer.style.opacity = 0
    },
    openDialog(type, item) {
      this.dialogInfo = item
      this.dialogInfo.type = type
      this.$refs.dialog.style.clipPath = 'polygon(0 0, 100% 0, 100% 100%, 0 100%)'
    },
    closeDialog() {
      this.$refs.dialog.style.clipPath = 'polygon(70% 0, 70% 0, 30% 100%, 30% 100%)'
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('https://cdn.bootcdn.net/ajax/libs/fullPage.js/3.1.2/fullpage.css');

.layout-container {
  --ratio: calc(100vw / 1920);
  position: relative;
  background: no-repeat center/cover url('../assets/apps_bg.png');
  background-attachment: fixed;

  nav {
    width: 100%;
    display: flex;
    padding: calc(50*var(--ratio));
    position: fixed;
    z-index: 99;

    #logo {
      height: calc(40*var(--ratio));
    }

    aside {
      margin-left: auto;
      display: flex;
      align-items: center;
      gap: calc(60*var(--ratio));

      &.white {

        #menu,
        .el-icon-bell,
        .username {
          filter: grayscale(100) contrast(100) invert(100);
        }
      }

      #menu {
        display: flex;
        gap: calc(60*var(--ratio));

        li {
          display: flex;
          transition: 300ms ease-in-out;
          color: #656565;
          font-size: calc(18*var(--ratio));

          &.active {
            color: $homeRed;
            font-weight: bold;

            & a::after {
              width: 100%;
            }
          }

          &:hover:not(.active) {
            color: $homeRed;
          }

          a::after {
            display: block;
            content: '';
            width: 0;
            height: calc(3*var(--ratio));
            background: $homeRed;
            transition: 500ms ease-in-out;
            margin-top: calc(8*var(--ratio));
          }
        }
      }

      .el-icon-bell {
        font-size: calc(20*var(--ratio));
        color: $homeRed;
        transform: translateY(calc(-2*var(--ratio)));
        cursor: pointer;
        overflow: hidden;

        &:hover::after {
          left: 0;
        }

        &::after {
          content: '\e799';
          font-family: element-icons;
          position: absolute;
        }

      }

      .el-dropdown {
        cursor: pointer;
        transform: translateY(calc(-6*var(--ratio)));

        &-link {
          display: flex;
          align-items: center;
          gap: calc(10*var(--ratio));

          span {
            font-size: calc(16*var(--ratio));
            color: #656565;
          }

          img {
            width: calc(30*var(--ratio));
            height: calc(30*var(--ratio));
            border-radius: 50%;
          }
        }
      }
    }
  }

  footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: calc(90*var(--ratio));
    transition: 300ms ease-in-out;
    z-index: 99;
    display: flex;
    background: #fff;

    .suggestion {
      height: 100%;
      flex-grow: 1;
      border-top: 1px solid #ddd;
      padding: calc(10*var(--ratio)) calc(50*var(--ratio));
      display: flex;
      align-items: center;
      gap: calc(50*var(--ratio));

      img {
        height: calc(120*var(--ratio));
      }

      .info {
        display: flex;
        flex-direction: column;
        gap: calc(15*var(--ratio));

        .title {
          font-size: calc(18*var(--ratio));
          font-weight: bold;
          color: $pointColor
        }

        .desc {
          font-size: calc(16*var(--ratio));
          color: $contentColor;
        }
      }

      .action {
        font-size: calc(12*var(--ratio));
        color: $homeRed;
        font-weight: bold;
        padding: calc(8*var(--ratio)) calc(15*var(--ratio));
        border-radius: calc(20*var(--ratio));
        border: 1px solid $homeRed;
        transition: 300ms;
        white-space: nowrap;
        cursor: pointer;

        &:hover {
          color: #fff;
          background: $homeRed;
          border: 1px solid $homeRed;
        }
      }
    }

    label {
      height: 100%;
      width: calc(250*var(--ratio));
      justify-content: center;
      color: #fff;
      cursor: pointer;
      transition: 300ms;

      span {
        font-size: calc(18*var(--ratio));
        font-weight: bold;
      }

      &.msg {
        background: $homeBlue ;

        &:hover {
          background: lighten($homeBlue, 10%);
        }

      }

      &.app {
        background: $homeRed;

        &:hover {
          background: lighten($homeRed, 10%);
        }
      }
    }
  }

  .drawer {
    transform: translateX(1px);
    position: fixed;
    top: calc(90*var(--ratio));
    right: 0;
    width: 0;
    height: calc(100vh - 180*var(--ratio));
    border-left: 1px solid;
    border-image: linear-gradient(to top, #ddd 70%, transparent) 1;
    transition: 300ms ease-in-out;
    backdrop-filter: blur(10px);
    overflow: hidden;
    justify-content: flex-end;
    z-index: 99;

    &.white {
      height: calc(100vh - 90*var(--ratio));
      background: linear-gradient(to top, #1850A250 70%, transparent);

      .tip-wrapper {
        .first {
          color: #fff;

          &:hover {
            color: #fff;
            background: linear-gradient(to left, #ffffff00, #ffffff30);
          }
        }

        .msg-item {

          &:hover {
            background: linear-gradient(to left, #ffffff00, #ffffff30);

            .date {

              .day,
              .year-month {
                color: #fff;
              }
            }

            & .content {
              .top {

                .title,
                .time {
                  color: #fff;
                }
              }

              .detail {
                color: #fff
              }
            }
          }

          .date {
            .day {
              color: #fff;
            }

            .year-month {
              color: #fff;
            }
          }

          .content {
            .top {
              .title {
                color: #fff;
              }

              .time {
                color: #fff;
              }
            }

            .detail {
              color: #fff;
            }
          }
        }
      }
    }

    .tip-wrapper,
    .msg-wrapper {
      width: 100%;
      height: 100%;

      .first {
        width: 100%;
        height: calc(100% / 9);
        transition: 300ms;
        font-size: calc(18*var(--ratio));
        justify-content: flex-start;
        white-space: nowrap;

        span {
          margin-left: calc(30*var(--ratio));
        }

        .el-icon-right {
          transform: translateX(calc(10*var(--ratio)));
          animation: iconMove 2s infinite;
          animation-play-state: paused;
        }

        &:hover {
          background: linear-gradient(to left, #676aff00, #6a67ff20);
          cursor: pointer;
          color: $homeBlue;

          i {
            animation-play-state: running;
          }
        }
      }

      .msg-item {
        width: 100%;
        height: calc(100% / 9);
        transition: 300ms;

        &:hover {
          background: linear-gradient(to left, #676aff00, #6a67ff20);
          cursor: pointer;

          .date {

            .day,
            .year-month {
              color: $homeBlue;
            }
          }

          & .content {
            .top {

              .title,
              .time {
                color: $homeBlue;
              }
            }

            .detail {
              color: $homeBlue
            }
          }
        }

        .date {
          text-align: center;
          margin: 0 calc(20*var(--ratio)) 0 calc(30*var(--ratio));

          .day {
            font-size: calc(40*var(--ratio));
            font-family: math;
            line-height: 1;
            color: #999;
          }

          .year-month {
            font-size: calc(10*var(--ratio));
            color: #999;
          }
        }

        .el-divider {
          height: calc(50*var(--ratio));
        }

        .content {
          flex-grow: 1;
          width: 0;
          align-items: flex-start;
          margin: 0 calc(30*var(--ratio)) 0 calc(20*var(--ratio));

          .top {
            width: 100%;
            align-items: flex-start;

            .title {
              font-size: calc(20*var(--ratio));
              font-weight: bold;
              color: #333;
              flex-grow: 1;
              width: 0;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }

            .time {
              font-size: calc(12*var(--ratio));
              color: #666;
            }
          }

          .detail {
            font-size: calc(16*var(--ratio));
            width: 100%;
            color: #666;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            margin-top: calc(10*var(--ratio));
          }
        }
      }
    }

    .app-wrapper {
      width: 100%;
      height: 100%;

      .first {
        width: 100%;
        height: calc(100% / 9);
        transition: 300ms;
        font-size: calc(18*var(--ratio));
        justify-content: flex-start;
        white-space: nowrap;

        span {
          margin-left: calc(40*var(--ratio));
        }

        .el-icon-right {
          transform: translateX(calc(10*var(--ratio)));
          animation: iconMove 2s infinite;
          animation-play-state: paused;
        }

        &:hover {
          background: linear-gradient(to left, #FF676E00, #FF676E20);
          cursor: pointer;
          color: $homeRed;

          i {
            animation-play-state: running;
          }
        }
      }

      .apps-item {
        width: 100%;
        height: calc(100% / 9);
        transition: 300ms;
        font-size: calc(18*var(--ratio));
        justify-content: flex-start;
        white-space: nowrap;

        img {
          width: calc(30*var(--ratio));
          margin: 0 calc(20*var(--ratio)) 0 calc(40*var(--ratio));
        }

        &:hover {
          background: linear-gradient(to left, #FF676E00, #FF676E20);
          cursor: pointer;

          span {
            color: $homeRed;
          }
        }
      }
    }

    @keyframes iconMove {
      to {
        transform: translateX(calc(30*var(--ratio)));
      }
    }
  }

  .dialog {
    height: 100vh;
    width: 100vw;
    background: #00000080;
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    transition: 300ms ease-in-out;
    overflow: hidden;
    display: flex;
    clip-path: polygon(70% 0, 70% 0, 30% 100%, 30% 100%);
    backdrop-filter: blur(10px);

    &-body {
      margin: auto;
      background: #fff;
      padding: calc(30*var(--ratio));
      width: 48vw;
      height: 70vh;
      position: relative;
      display: flex;
      flex-direction: column;
      border: calc(3*var(--ratio)) solid transparent;
      // background: linear-gradient(#fff, #fff) padding-box, repeating-linear-gradient(-45deg, $homeRed 0, $homeRed 12.5%, #fff 0, #fff 25%, $homeBlue 0, $homeBlue 37.5%, #fff 0, #fff 50%) 0/calc(80*var(--ratio)) calc(80*var(--ratio));

      ul {
        flex-grow: 1;
        overflow: auto;
        margin-bottom: calc(20*var(--ratio));

        &::-webkit-scrollbar {
          display: none;
        }

        li {
          display: flex;
          align-items: center;
          font-size: calc(15*var(--ratio));

          i {
            color: $contentColor;
            margin-right: calc(8*var(--ratio));
          }

          dt {
            color: $contentColor;
          }

          dd {
            color: $titleColor;
          }
        }

        .el-divider {
          margin: calc(15*var(--ratio)) 0;
        }
      }

      img {
        width: calc(120*var(--ratio));
        position: absolute;
        right: calc(30*var(--ratio));
        bottom: calc(30*var(--ratio));
        transform: rotate(-20deg);
      }

      .dialog-title {
        font-size: calc(22*var(--ratio));
        font-weight: bold;
        color: $titleColor;

        &::after {
          content: '';
          display: block;
          width: 100%;
          height: 1.5px;
          background: $hoverColor;
          margin-top: calc(10*var(--ratio));
        }
      }

      .dialog-content {
        width: 100%;
        margin: calc(20*var(--ratio)) 0;
        flex-grow: 1;
        font-size: calc(15*var(--ratio));
        color: $contentColor;
        line-height: calc(30*var(--ratio));
        white-space: pre-wrap;
        word-wrap: break-word;
        overflow: auto;

        &::-webkit-scrollbar {
          display: none;
        }
      }

      .dialog-footer {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        &::before {
          content: '';
          display: block;
          width: 100%;
          height: 1.5px;
          background: $hoverColor;
          margin-bottom: calc(20*var(--ratio));
        }

        .type {
          color: $homeRed;
          font-weight: bold;
          font-size: calc(14*var(--ratio));
        }

        .time {
          color: $homeBlue;
          font-size: calc(14*var(--ratio));
          font-family: math;
        }
      }
    }
  }
}
</style>
<style lang="scss">
#fp-nav ul li a span,
.fp-slidesNav ul li a span {
  background: #fff;
}
</style>
